import React from 'react';
import Header from '../Header/Header';
import { InsiderModel } from './Insidermodel';


const Insider = () => {
    const insiderModel = InsiderModel();
    return (
        <>
            <Header />
            <div className="container">
                <div className="row mt-5">
                    <div className="col-12 mt-5">
                        <div className="title-color border-bottom_card">
                            <a href="#" style={{ 'color': '#fff' }}>
                                <h3 className='text-start' onClick={(e)=>insiderModel.back()}>
                                    <i className="fa fa-chevron-left mx-2"></i>
                                    Insider
                                </h3>
                            </a>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-8 mx-auto mt-4">
                        <div className="input-group w-24">
                            <input type="text" className="form-control box-shadow-none fs-13 border-0 bg-color" placeholder="Search" aria-label="Recipient's username" aria-describedby="basic-addon2" 
                             onChange={insiderModel.handleChange}/>
                            <div className="input-group-append">
                                <span className="input-group-text border-radius search-bg border-0" id="basic-addon2"><button type="submit" title="Search" className="border-0 bg-transparent">
                                    <i className="bi bi-search"></i></button>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-8 mt-3 mx-auto ">
                        <ul style={{ 'listStyle': 'none', 'display': 'flex' }} className="p-0">
                            <li className="mx-2"><button type="button" onClick={(e) => insiderModel.selectTab('sold')} className={insiderModel.activeTab == 'sold' ? 'btn btn-reward w-100 fs-15 fw-600' : 'btn btn-secondary'}>Sold</button></li>
                            <li className="mx-2"><button type="button" onClick={(e) => insiderModel.selectTab('bought')} className={insiderModel.activeTab == 'bought' ? 'btn btn-reward w-100 fs-15 fw-600' : 'btn btn-secondary'}>Bought</button></li>
                            
                        </ul>
                    </div>
                </div>
                <div className="row">

                    <div className="col-md-12 mt-2 mx-auto">
                        <div className="row bullish_cards">
                            {
                                insiderModel.lstInsidersTickers.length > 0 ? (insiderModel.lstInsidersTickers && insiderModel.lstInsidersTickers.map((d: any, index: number) => (
                                    <div className="col-12 col-md-6 card rounded-1">
                                        <div className="card-body">
                                            <div className="row title-color mb">
                                                <div className="col-6 mb-2 text-start">
                                                    <h5>{d.symbol}</h5>
                                                </div>
                                                <div className="col-12 text-start ">
                                                    <h6 className="trending_text1">Name: {d.name}</h6>
                                                    <h6 className="trending_text1">Share: {d.share}</h6>
                                                    <h6 className="trending_text1 m-0">Change: {d.change}</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))) :
                                <div className="col-md-6 mx-auto">
                                    <img src="../assets/img/icons_svg/no-data.svg" alt="" />
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Insider;